import React, { Fragment, Suspense } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import * as actions from '../../../actions/homeData';

import Icon from '../../../refresh/atoms/Icon';
import { getSearchFlags } from '../../../refresh/selectors/featureFlagsSelector';
import { getSearchExpFlags } from '../../../utils/products';
import {getAmplitudeVariantPayload,  getAmplitudeVariantFlag, getAmplitudeVariantPayloadMap } from '../../../utils/amplitudeCommon';

const SearchContainerBody = React.lazy(() =>
  import(
    /* webpackChunkName: "static/chunk/mobile/SearchContainerBody" */ './SearchContainerBody.js'
  )
);

class SearchBar extends React.Component {
  constructor() {
    super();
    this.state = {
      showResults: false,
      showSuggession: false,
      showTopSearches: true,
      inputval: ''
    };
    this.searchIconRef = React.createRef();
  }

  componentDidMount() {
    if (this.searchIconRef.current) {
      this.searchIconRef.current.focus();
    }
  }

  validateSearchInput = (inputStr = '') => {
    if (typeof inputStr === 'string' && inputStr) {
      inputStr = inputStr.trim();
      const regex = /[a-z0-9]+/i;
      if (inputStr && regex.test(inputStr)) {
        return true;
      }
    }
    return false;
  };

  topSearchesListItemRenderer = ({ index }) => {
    const { topSearches = [], ABFlagObj = {} } = this.props;
    const suggestion = topSearches[index];
    const searchAppendUrl = `${
      Object.keys(ABFlagObj)?.length > 0 ? `&${qs.stringify({ ...ABFlagObj })}` : ''
    }`;
    const searhText = `/search/?text=${suggestion.value}${searchAppendUrl}`;
    console.log('🚀 ~ file: SearchBar.js:37 ~ SearchBar ~ searhText:', searhText);
    return (
      <a href={searhText} className="ic-rchevron search-suggestionList">
        <span>{suggestion.url}</span>
      </a>
    );
  };

  hideSearchContainer = () => {
    this.setState({ showSearchContainer: false });
  };

  hideSearchBarAndShowContainer = () => {
    this.setState({
      showTopSearches: false,
      showSearchContainer: true
    });
  };

  updateInputValue = value => {
    this.setState({ inputval: value });
  };

  suggestionListItemRenderer = ({ index }) => {
    const { suggestions = [], ABFlagObj = {} } = this.props;
    const suggestion = suggestions[index];
    const item = suggestion.value;
    var suggestionUrl = suggestion.url;
    let { absolutePath = false, customClass = '', sis = false } = suggestion;
    const urlSplits = suggestionUrl.split(':');
    var autoSuggestionUrl = `/search/?text=${suggestionUrl.trim()}`;
    // if (urlSplits[0] == "categoryID" || urlSplits[0] == "brands") {
    //   autoSuggestionUrl = `/search/?text=${suggestionUrl.trim()}`;
    // }

    if (absolutePath) {
      autoSuggestionUrl = suggestionUrl;
    }
    const searchAppendUrl = `${
      Object.keys(ABFlagObj)?.length > 0 ? `&${qs.stringify({ ...ABFlagObj })}` : ''
    }`;
    autoSuggestionUrl = `${autoSuggestionUrl}${searchAppendUrl}`;
    console.log('🚀 ~ file: SearchBar.js:71 ~ SearchBar ~ autoSuggestionUrl:', autoSuggestionUrl);
    const splitted = item.split(' in ');
    const lastWord = splitted.pop();
    let newTxt = '';
    if (splitted.length > 0) {
      newTxt = `${splitted.join(' ')} in `;
    } else {
      newTxt = splitted;
    }
    return (
      <a
        href={autoSuggestionUrl}
        className={`ic-rchevron search-suggestionList ${customClass || ''}`}
      >
        {sis ? <span className="ic-app-logo"> </span> : ''}
        <span>{newTxt}</span> <span className="higlighted-text">{lastWord}</span>
      </a>
    );
  };

  render() {
    const {
      showSearchBlock = false,
      suggestions = [],
      topSearches = [],
      metaData: {
        sis = false,
        name = 'Ajio',
        themeColor = 'transparent',
        // textColor = "#FFF",
        current: { textColor = '#FFF' } = {}
      } = {},
      clearSearchDetailsResponse,
      fetchData
    } = this.props;
    const { showTopSearches = false, showSearchContainer = false } = this.state;
    const styleIcon = Object.freeze({
      fontSize: '1.8rem'
    });
    return (
      <div className="search-comp">
        {!showSearchBlock && (
          <div
            tabIndex={0}
            role="button"
            aria-label="ajio gram explore screen search"
            ref={this.searchIconRef}
            className="icon-Search"
            style={{ color: sis ? textColor : '#2c4152' }}
            onClick={e => {
              this.setState({ showSearchContainer: true, showTopSearches: true });
              this.props.fetchTopSearches();
            }}
          >
            <Icon ariaLabel="Search" icon="icon-Search" styles={styleIcon} ariaHidden />
          </div>
        )}
        {showSearchBlock && (
          <div
            id="search-block"
            className="search-block"
            onClick={e => {
              this.setState({ showSearchContainer: true, showTopSearches: true });
              this.props.fetchTopSearches();
            }}
          >
            <span className="ic-search search-block-icon">
              <p className="search-block-text">What would you like to shop today ?</p>
            </span>
          </div>
        )}
        <div className={`search-container ${showSearchContainer ? 'open-search' : 'close-search'}`}>
          {showSearchContainer && (
            <Suspense fallback={<div />}>
              <SearchContainerBody
                sis={sis}
                name={name}
                suggestions={suggestions}
                showTopSearches={showTopSearches}
                topSearches={topSearches}
                clearSearchDetailsResponse={clearSearchDetailsResponse}
                hideSearchContainer={this.hideSearchContainer}
                hideSearchBarAndShowContainer={this.hideSearchBarAndShowContainer}
                fetchData={fetchData}
                updateInputValue={this.updateInputValue}
                topSearchesListItemRenderer={this.topSearchesListItemRenderer}
                suggestionListItemRenderer={this.suggestionListItemRenderer}
                validateSearchInput={this.validateSearchInput}
              />
            </Suspense>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { search = {}, metaData = {} } = state;
  const { suggestions = [], topSearches = [] } = search;

  const searchFlags = getAmplitudeVariantPayload('searchExpFlags',state, getSearchFlags(state));
  

  let ABFlagObj = (state?.flags?.amplitude_experiment_flag == 'ON') ? getAmplitudeVariantPayloadMap(searchFlags, state) : getSearchExpFlags(searchFlags);
  

  return {
    suggestions,
    topSearches,
    metaData,
    ABFlagObj: ABFlagObj || {}
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchData: debounce((value, sis) => {
      dispatch(actions.getSearchDetails(value, sis));
    }, 700),
    fetchTopSearches: () => dispatch(actions.fetchTopSearches()),
    clearSearchDetailsResponse: () => dispatch(actions.clearSearchDetailsResponse())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchBar);
